import React from "react"
import { serialize as baseSerialize } from "@convertkit/editor"
import { VideoEmbed } from "../custom-elements/video-embed"
import { TimerImage } from "app/editor/plugins/countdown-timer"

const ProductSerializer = {
  serialize(node) {
    if (node.object === "block" && node.type === "product") {
      const { url, domain } = node.data.toJS()
      const text = node.nodes.map(node => node.text).join()
      const html = `<script src="https://${domain}/commerce.js" async defer></script>\n<a class="convertkit-button" href="${url}" data-commerce>${text}</a>`

      return <div dangerouslySetInnerHTML={{ __html: html }} />
    }
  }
}

const VideoEmbedSerializer = {
  serialize(node) {
    if (node.object === "block" && node.type === "video-embed") {
      return <VideoEmbed {...node.data.toJS()} editing={false} />
    }
  }
}

const TimerSerializer = {
  serialize(node) {
    if (node.object === "block" && node.type === "timer") {
      return (
        <TimerImage
          slug={node.data.get("slug")}
          url={node.data.get("url")}
          version={node.data.get("version")}
          editing={false}
        />
      )
    }
  }
}

export function serialize(
  value,
  { type = "text/html", target = "email", theme = {}, find = () => {} } = {}
) {
  return baseSerialize(value, {
    type,
    target,
    theme,
    find,
    rules: [ProductSerializer, VideoEmbedSerializer, TimerSerializer]
  })
}
